import { render, staticRenderFns } from "./float-customer-service-mini.vue?vue&type=template&id=4405e297&scoped=true"
import script from "./float-customer-service-mini.vue?vue&type=script&lang=js"
export * from "./float-customer-service-mini.vue?vue&type=script&lang=js"
import style0 from "./float-customer-service-mini.vue?vue&type=style&index=0&id=4405e297&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4405e297",
  null
  
)

export default component.exports